export default __webpack_public_path__ + "_/images/knowledge-center/category-betting-901d66950fd5ec8e7443dbd3d310ee0810968d3ea61834ee9e7f5bdbb49400af.png";